import { render, staticRenderFns } from "./SupervisorsTab.vue?vue&type=template&id=1f7a2819&scoped=true&"
import script from "./SupervisorsTab.vue?vue&type=script&lang=js&"
export * from "./SupervisorsTab.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorsTab.vue?vue&type=style&index=0&id=1f7a2819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7a2819",
  null
  
)

export default component.exports